import { createStore, combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import { persistStore, persistReducer } from 'redux-persist';
import reduxStorage from 'redux-persist/lib/storage';
import {
  loader, notify, user, menu, selectCaseDate, online,
  serverUrl, products, scanner, goBack, otherCharge, caseFilter, team, preference,
  missingDgrsFilter, missingPosFilter, notBilledFilter, billedFilter,
  tableName, selectedExpressSets, lotScanner, firstLoginSessionToken,
  setsSearch, setsListStateStorage, preferenceOptions, searchBilledData, officeSetsFilter,
  expressCareSetsFilter, setsFilter, notBillingFilter, searchBilledCaseCountData, calendarFilter,
  selectedSetsPayload, searchFilter, scanInventory, singleScanSession, inventoryFilter,
  scanInventoryScanner, vhnPpcOtherCharge, updatedRoute, dersDetails, caseDer, derFilter,
  derSearchFilter, dersProducts, dersFilterResult, viewDersDetails, isShowButtons, selectCaseId,
  aggregatePlan, notifications, prevRoute, salesFilter, setsToMove, derModal, salesYTD,
  readOnlyProductNotes, readCaseData, autoLoginData, surgeonNote, savedScrollPosition, themeColor,
  themeDetectColor, themeColorNumber, calendarMonthEndDate, browserDetect,
} from './reducers';

const persistConfig = {
  key: 'root',
  storage: reduxStorage,
  whitelist: [
    'user',
    'serverUrl',
    'goBack',
    'preference',
    'caseFilter',
    'team',
    'missingDgrsFilter',
    'missingPosFilter',
    'notBilledFilter',
    'billedFilter',
    'tableName',
    'setsSearch',
    'online',
    'setsListStateStorage',
    'searchBilledData',
    'officeSetsFilter',
    'expressCareSetsFilter',
    'setsFilter',
    'notBillingFilter',
    'searchBilledCaseCountData',
    'calendarFilter',
    'scanner',
    'products',
    'selectCaseDate',
    'selectedSetsPayload',
    'scanInventory',
    'singleScanSession',
    'inventoryFilter',
    'firstLoginSessionToken',
    'scanInventoryScanner',
    'vhnPpcOtherCharge',
    'updatedRoute',
    'dersDetails',
    'caseDer',
    'derFilter',
    'derSearchFilter',
    'dersProducts',
    'dersFilterResult',
    'viewDersDetails',
    'isShowButtons',
    'selectCaseId',
    'aggregatePlan',
    'autoLoginData',
    'surgeonNote',
    'savedScrollPosition',
    'themeColor',
    'themeDetectColor',
    'themeColorNumber',
    'calendarMonthEndDate',
    'browserDetect',
  ],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    loader,
    notify,
    user,
    menu,
    selectCaseDate,
    online,
    serverUrl,
    products,
    scanner,
    goBack,
    otherCharge,
    caseFilter,
    team,
    preference,
    missingDgrsFilter,
    missingPosFilter,
    notBilledFilter,
    billedFilter,
    tableName,
    selectedExpressSets,
    lotScanner,
    setsSearch,
    setsListStateStorage,
    preferenceOptions,
    searchBilledData,
    officeSetsFilter,
    expressCareSetsFilter,
    setsFilter,
    notBillingFilter,
    searchBilledCaseCountData,
    calendarFilter,
    selectedSetsPayload,
    searchFilter,
    scanInventory,
    singleScanSession,
    inventoryFilter,
    firstLoginSessionToken,
    scanInventoryScanner,
    vhnPpcOtherCharge,
    updatedRoute,
    dersDetails,
    caseDer,
    derFilter,
    derSearchFilter,
    dersProducts,
    viewDersDetails,
    dersFilterResult,
    selectCaseId,
    isShowButtons,
    aggregatePlan,
    notifications,
    prevRoute,
    salesFilter,
    setsToMove,
    derModal,
    salesYTD,
    readOnlyProductNotes,
    readCaseData,
    autoLoginData,
    surgeonNote,
    savedScrollPosition,
    themeColor,
    themeDetectColor,
    themeColorNumber,
    calendarMonthEndDate,
    browserDetect,
    form: reduxFormReducer,
  })
);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);
